import DOMPurify from 'dompurify';
import {
  UserWalletBenefitCard,
  CardImages,
  CardImage,
} from '@leagueplatform/wallet-api';

const LEAGUE_STATIC_URL_REGEX = /https:\/\/app\.league\.com\/static/g;
/**
 * Cards have their images urls point absolutely to prod, which isn't great
 * Instead, use the absolute url for local and otherwise point use relative URL
 * */

export const updateCardHtmlUrls = (html: string) => {
  if (!html) {
    console.error('HTML is required');
    return undefined;
  }

  return html.replace(LEAGUE_STATIC_URL_REGEX, '/static');
};

const formatCardHtmlFace = (
  htmlString: string | undefined,
): CardImage | undefined => {
  if (!htmlString) {
    return undefined;
  }

  return {
    description: '',
    src: DOMPurify.sanitize(htmlString, {
      FORCE_BODY: true,
      ALLOWED_ATTR: ['class', 'style', 'role'],
    }),
    type: 'html',
  };
};

export const selectCardHtml = (
  data: UserWalletBenefitCard,
): CardImages | null => {
  // there's a discrepancy in how get_wallet and get_wallet_dependent_cards
  // return card data. before that's addressed in the BE, we have to check for both
  const dependentCardHtml = data.rendered_template?.front;
  const primaryMemberCardHtml = data.card_images?.front.src;
  const primaryMemberBackCardHtml = data.card_images?.back?.src;

  const validHtml = primaryMemberCardHtml ?? dependentCardHtml;
  const front = formatCardHtmlFace(
    validHtml ? updateCardHtmlUrls(validHtml) : undefined,
  );
  const back = formatCardHtmlFace(
    primaryMemberBackCardHtml
      ? updateCardHtmlUrls(primaryMemberBackCardHtml)
      : undefined,
  );

  if (!front) {
    return null;
  }

  return {
    front,
    back,
  };
};
